import React from 'react';
import { omit } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Icon, Input, InputGroup } from 'rsuite';

const FileSearch = ({
  query,
  queryOptions,
  placeholder,
  onChange,
  onSubmit,
  isFetching
}) => {
  const handleOnChange = q => {
    onChange({ q });
  };
  return (
    <InputGroup style={{ width: 400, float: 'left' }}>
      <Input
        value={query}
        onChange={handleOnChange}
        style={{ paddingLeft: 10 }}
        placeholder={placeholder}
        disabled={isFetching}
        onKeyPress={({ key }) => {
          if (key === 'Enter' && query !== '') onSubmit(queryOptions);
        }}
      />
      <InputGroup.Button
        style={{ borderBottom: 'none' }}
        disabled={!query || isFetching}
        onClick={() => {
          if (query !== '') onSubmit(queryOptions);
        }}
      >
        <Icon icon="search" />
      </InputGroup.Button>
      {query && (
        <InputGroup.Button
          style={{ borderBottom: 'none' }}
          disabled={isFetching}
          onClick={() => {
            handleOnChange('');
            onSubmit(omit('q', queryOptions));
          }}
        >
          <Icon icon="refresh" />
        </InputGroup.Button>
      )}
    </InputGroup>
  );
};

FileSearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
  queryOptions: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired
};

FileSearch.defaultProps = {
  queryOptions: {}
};

export default FileSearch;
